import { MessageCircle, User, Server, Table2, UserCog, ArrowRight, Zap, CheckCircle2 } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const Chip = ({ icon: Icon, label, tone = "default" }) => {
  const tones = {
    default: "border-white/12 bg-[#0a0a0a] text-neutral-300",
    human: "border-amber-500/30 bg-amber-500/5 text-amber-400/90",
    solid: "border-white bg-white text-black",
  };
  return (
    <div className={`inline-flex items-center gap-2 rounded-sm border px-3.5 py-2.5 shrink-0 ${tones[tone]}`}>
      <Icon className="h-4 w-4" strokeWidth={1.5} />
      <span className="font-mono text-[11px] md:text-xs whitespace-nowrap">{label}</span>
    </div>
  );
};

const Arrow = () => <ArrowRight className="h-4 w-4 text-neutral-700 shrink-0" />;

export const BeforeAfter = () => {
  return (
    <section id="before-after" className="relative py-28 md:py-40 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <Overline>Antes e depois</Overline>
          <h2 className="font-display font-extrabold text-3xl md:text-5xl tracking-tight leading-[1.05] mt-6 max-w-[24ch]">
            O problema raramente é a falta de software.
            <span className="text-neutral-500"> É o trabalho humano usado para transportar informação entre eles.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-[1px] bg-white/10 border border-white/10 rounded-sm overflow-hidden">
          {/* ANTES */}
          <Reveal className="bg-[#0a0a0a]">
            <div className="p-7 md:p-10">
              <div className="flex items-center gap-3 mb-6">
                <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-amber-500/80">Antes</span>
                <span className="h-px flex-1 bg-white/10" />
                <span className="font-mono text-[11px] text-neutral-600">pessoas como integração</span>
              </div>
              <div className="flex items-center gap-2.5 md:gap-3 flex-wrap">
                <Chip icon={MessageCircle} label="WhatsApp" />
                <Arrow />
                <Chip icon={User} label="pessoa" tone="human" />
                <Arrow />
                <Chip icon={Server} label="Sistema" />
                <Arrow />
                <Chip icon={User} label="pessoa" tone="human" />
                <Arrow />
                <Chip icon={Table2} label="Planilha" />
                <Arrow />
                <Chip icon={User} label="pessoa" tone="human" />
                <Arrow />
                <Chip icon={UserCog} label="Cliente" />
              </div>
            </div>
          </Reveal>

          {/* DEPOIS */}
          <Reveal delay={0.1} className="bg-[#0a0a0a]">
            <div className="p-7 md:p-10">
              <div className="flex items-center gap-3 mb-6">
                <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-white">Depois</span>
                <span className="h-px flex-1 bg-white/10" />
                <span className="font-mono text-[11px] text-neutral-600">camada de automação</span>
              </div>
              <div className="grid md:grid-cols-[auto_auto_auto_auto_auto] gap-4 md:gap-3 items-center">
                <div className="flex flex-col gap-2">
                  <Chip icon={MessageCircle} label="WhatsApp" />
                  <Chip icon={Server} label="Sistema" />
                  <Chip icon={Table2} label="Planilha" />
                </div>
                <div className="hidden md:flex justify-center"><Arrow /></div>
                <Chip icon={Zap} label="Camada de automação" tone="solid" />
                <div className="hidden md:flex justify-center"><Arrow /></div>
                <Chip icon={CheckCircle2} label="Ações e resultados" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
